var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299 299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1ed760;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spotify"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m149.5,0C66.81,0,0,66.98,0,149.5s66.98,149.5,149.5,149.5,149.5-66.98,149.5-149.5S232.02,0,149.5,0Zm68.58,215.77c-2.68,4.47-8.4,5.71-12.86,3.04-35.19-21.43-79.31-26.26-131.47-14.47-5,1.07-10-1.96-11.07-6.96s1.96-10,6.96-11.07c56.98-13.03,105.91-7.5,145.21,16.61,4.43,2.64,5.89,8.38,3.25,12.81-.01.02-.02.03-.03.05h.01Zm18.22-40.72c-3.39,5.54-10.54,7.15-16.07,3.92-40.19-24.65-101.45-31.79-148.96-17.51-6.25,1.78-12.68-1.61-14.47-7.68-1.78-6.25,1.61-12.68,7.86-14.47,54.3-16.43,121.81-8.57,168.08,19.83,5.36,3.21,6.96,10.36,3.57,15.9h0Zm1.61-42.51c-48.23-28.58-127.71-31.25-173.79-17.32-7.33,2.32-15.18-1.96-17.51-9.29s1.96-15.18,9.29-17.51c52.87-16.07,140.75-12.86,196.13,20,6.61,3.92,8.75,12.5,4.82,19.11-3.57,6.79-12.32,8.93-18.94,5h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/Spotify.2a18a15752c66137c2f32248ce6cdf2b.svg";
export { ForwardRef as ReactComponent };